module.exports = __webpack_public_path__ + "img/home-header-user.b59fb278.png";